module.exports = __webpack_public_path__ + "img/ic_sunrise_sunset.d046c57e.png";